import { ClientLog } from 'src/constants/clientLog';
import ClientLogger from '../logger';

/**
 * Processes a comma-delimited string of key values into a structured object.
 *
 * @param metaTagContent - Raw string from meta tag in format "WEBLAB1=T1,WEBLAB2=C"
 * @returns A formatted record mapping of key values derived from the raw meta tag content string.
 *
 * @example
 * // Input: "FEATURE_A=T1,FEATURE_B=C"
 * // Output: { FEATURE_A: "T1", FEATURE_B: "C" }
 *
 * @throws Silently handles parsing errors by returning an empty object.
 */
export const parseKeyValuePairs = (metaTagContent: string) => {
  try {
    const keyValueArray: string[] = metaTagContent.split(',');
    const keyValueObject: Record<string, string> = {};
    keyValueArray.forEach((keyValueString) => {
      const [key, value] = keyValueString.split('=', 2);
      keyValueObject[key] = value;
    });
    return keyValueObject;
  } catch (error) {
    const logContext = {
      metaTagContent,
      error,
    };
    ClientLogger.error(ClientLog.MetaTagProcessingException, logContext);
    return {};
  }
};
